import 'jquery';
// import 'jquery-ui-dist/jquery-ui';
import 'bootstrap/dist/js/bootstrap';
import angular from 'angular';
import 'angular-ui-router';
import 'angular-resource';
import 'angular-cookies';
import 'angular-segment-analytics';
import 'angular-ui-bootstrap';
import 'js-sdk';
import smoothScrollPolyfill from 'smoothscroll-polyfill';
import 'angular-sanitize';
import 'angular-scroll';
import 'ngclipboard';
import 'src/vendor/ng-bs-animated-button';
import 'src/vendor/tablelist-js';

import npHttpInterceptor from 'services/httpInterceptor';
import appServices from 'services';
import appComponents from 'components';
import appConstants from 'constants';
import appDirectives from 'directives';
import appFilters from 'filters';
import rootScopeGlobals from './rootScopeGlobals';
import authentication from './authentication';
import stateChange from './stateChange';
import appConfig from './appConfig';
import routerConfig from './routerConfig';

import './styles/main.less';

smoothScrollPolyfill.polyfill();

const app = angular.module('tablelistApp', [
  'jsSdk',
  'ui.router',
  'ngSegment',
  'ui.bootstrap',
  'ng-bs-animated-button',
  'ngSanitize',
  'duScroll',
  'tl',
  'ngclipboard'
]);

appServices.init(app);
appComponents.init(app);
appConstants.init(app);
appDirectives.init(app);
appFilters.init(app);

app.factory('npHttpInterceptor', npHttpInterceptor);

app.config(appConfig);
app.config(routerConfig);

app.run(rootScopeGlobals);
app.run(authentication);
app.run(stateChange);

app.config(['$httpProvider',
  ($httpProvider) => {
    $httpProvider.interceptors.push('npHttpInterceptor');
  }
]);

export default app;



// WEBPACK FOOTER //
// ./src/main.js